import { IntraSyncDesignerViewStore } from "@intrasync/designer";
import SalesOrderConversionViewStore from "../workflows/SalesOrderConversion/SalesOrderConversionViewStore";

const estimatingStoresList = [
  { name: "intraSyncDesignerViewStore", store: IntraSyncDesignerViewStore },
  { name: "salesOrderConversionViewStore", store: SalesOrderConversionViewStore },
];

export default estimatingStoresList;
